"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.altiumRecordTypeNames = exports.AltiumRecordType = void 0;
/**
 * Represents the different types of records that can be found in an Altium design file.
 * Each record type has a unique integer identifier that is used to map the record to its corresponding Altium record class.
 *
 * @link https://github.com/vadmium/python-altium/blob/master/format.md
 */
var AltiumRecordType;
(function (AltiumRecordType) {
    // "ROOT" record type is not part of the Altium file format, but is used
    // to represent the root record in the parsed records tree
    AltiumRecordType[AltiumRecordType["ROOT"] = -2] = "ROOT";
    AltiumRecordType[AltiumRecordType["UNKNOWN"] = -1] = "UNKNOWN";
    AltiumRecordType[AltiumRecordType["HEADER"] = 0] = "HEADER";
    AltiumRecordType[AltiumRecordType["COMPONENT"] = 1] = "COMPONENT";
    AltiumRecordType[AltiumRecordType["PIN"] = 2] = "PIN";
    AltiumRecordType[AltiumRecordType["IEEE_SYMBOL"] = 3] = "IEEE_SYMBOL";
    AltiumRecordType[AltiumRecordType["LABEL"] = 4] = "LABEL";
    AltiumRecordType[AltiumRecordType["BEZIER"] = 5] = "BEZIER";
    AltiumRecordType[AltiumRecordType["POLYLINE"] = 6] = "POLYLINE";
    AltiumRecordType[AltiumRecordType["POLYGON"] = 7] = "POLYGON";
    AltiumRecordType[AltiumRecordType["ELLIPSE"] = 8] = "ELLIPSE";
    AltiumRecordType[AltiumRecordType["PIECHART"] = 9] = "PIECHART";
    AltiumRecordType[AltiumRecordType["ROUND_RECTANGLE"] = 10] = "ROUND_RECTANGLE";
    AltiumRecordType[AltiumRecordType["ELLIPTICAL_ARC"] = 11] = "ELLIPTICAL_ARC";
    AltiumRecordType[AltiumRecordType["ARC"] = 12] = "ARC";
    AltiumRecordType[AltiumRecordType["LINE"] = 13] = "LINE";
    AltiumRecordType[AltiumRecordType["RECTANGLE"] = 14] = "RECTANGLE";
    AltiumRecordType[AltiumRecordType["SHEET_SYMBOL"] = 15] = "SHEET_SYMBOL";
    AltiumRecordType[AltiumRecordType["SHEET_ENTRY"] = 16] = "SHEET_ENTRY";
    AltiumRecordType[AltiumRecordType["POWER_PORT"] = 17] = "POWER_PORT";
    AltiumRecordType[AltiumRecordType["PORT"] = 18] = "PORT";
    AltiumRecordType[AltiumRecordType["NO_ERC"] = 22] = "NO_ERC";
    AltiumRecordType[AltiumRecordType["NET_LABEL"] = 25] = "NET_LABEL";
    AltiumRecordType[AltiumRecordType["BUS"] = 26] = "BUS";
    AltiumRecordType[AltiumRecordType["WIRE"] = 27] = "WIRE";
    AltiumRecordType[AltiumRecordType["TEXT_FRAME"] = 28] = "TEXT_FRAME";
    AltiumRecordType[AltiumRecordType["JUNCTION"] = 29] = "JUNCTION";
    AltiumRecordType[AltiumRecordType["IMAGE"] = 30] = "IMAGE";
    AltiumRecordType[AltiumRecordType["SHEET"] = 31] = "SHEET";
    AltiumRecordType[AltiumRecordType["SHEET_NAME"] = 32] = "SHEET_NAME";
    AltiumRecordType[AltiumRecordType["FILE_NAME"] = 33] = "FILE_NAME";
    AltiumRecordType[AltiumRecordType["DESIGNATOR"] = 34] = "DESIGNATOR";
    AltiumRecordType[AltiumRecordType["BUS_ENTRY"] = 37] = "BUS_ENTRY";
    AltiumRecordType[AltiumRecordType["TEMPLATE"] = 39] = "TEMPLATE";
    AltiumRecordType[AltiumRecordType["PARAMETER"] = 41] = "PARAMETER";
    AltiumRecordType[AltiumRecordType["PARAMETER_SET"] = 43] = "PARAMETER_SET";
    AltiumRecordType[AltiumRecordType["IMPLEMENTATION_LIST"] = 44] = "IMPLEMENTATION_LIST";
    AltiumRecordType[AltiumRecordType["IMPLEMENTATION"] = 45] = "IMPLEMENTATION";
    AltiumRecordType[AltiumRecordType["MAP_DEFINER_LIST"] = 46] = "MAP_DEFINER_LIST";
    AltiumRecordType[AltiumRecordType["MAP_DEFINER"] = 47] = "MAP_DEFINER";
    AltiumRecordType[AltiumRecordType["IMPL_PARAMS"] = 48] = "IMPL_PARAMS";
    AltiumRecordType[AltiumRecordType["NOTE"] = 209] = "NOTE";
    AltiumRecordType[AltiumRecordType["COMPILE_MASK"] = 211] = "COMPILE_MASK";
    AltiumRecordType[AltiumRecordType["HARNESS_CONNECTOR"] = 215] = "HARNESS_CONNECTOR";
    AltiumRecordType[AltiumRecordType["HARNESS_ENTRY"] = 216] = "HARNESS_ENTRY";
    AltiumRecordType[AltiumRecordType["HARNESS_TYPE"] = 217] = "HARNESS_TYPE";
    AltiumRecordType[AltiumRecordType["SIGNAL_HARNESS"] = 218] = "SIGNAL_HARNESS";
    AltiumRecordType[AltiumRecordType["BLANKET"] = 225] = "BLANKET";
    AltiumRecordType[AltiumRecordType["HYPERLINK"] = 226] = "HYPERLINK";
})(AltiumRecordType || (exports.AltiumRecordType = AltiumRecordType = {}));
/**
 * Mapping of Altium record types to their corresponding names
 */
exports.altiumRecordTypeNames = {
    [AltiumRecordType.ROOT]: "ROOT",
    [AltiumRecordType.UNKNOWN]: "UNKNOWN",
    [AltiumRecordType.HEADER]: "HEADER",
    [AltiumRecordType.COMPONENT]: "COMPONENT",
    [AltiumRecordType.PIN]: "PIN",
    [AltiumRecordType.IEEE_SYMBOL]: "IEEE_SYMBOL",
    [AltiumRecordType.LABEL]: "LABEL",
    [AltiumRecordType.BEZIER]: "BEZIER",
    [AltiumRecordType.POLYLINE]: "POLYLINE",
    [AltiumRecordType.POLYGON]: "POLYGON",
    [AltiumRecordType.ELLIPSE]: "ELLIPSE",
    [AltiumRecordType.PIECHART]: "PIECHART",
    [AltiumRecordType.ROUND_RECTANGLE]: "ROUND_RECTANGLE",
    [AltiumRecordType.ELLIPTICAL_ARC]: "ELLIPTICAL_ARC",
    [AltiumRecordType.ARC]: "ARC",
    [AltiumRecordType.LINE]: "LINE",
    [AltiumRecordType.RECTANGLE]: "RECTANGLE",
    [AltiumRecordType.SHEET_SYMBOL]: "SHEET_SYMBOL",
    [AltiumRecordType.SHEET_ENTRY]: "SHEET_ENTRY",
    [AltiumRecordType.POWER_PORT]: "POWER_PORT",
    [AltiumRecordType.PORT]: "PORT",
    [AltiumRecordType.NO_ERC]: "NO_ERC",
    [AltiumRecordType.NET_LABEL]: "NET_LABEL",
    [AltiumRecordType.BUS]: "BUS",
    [AltiumRecordType.WIRE]: "WIRE",
    [AltiumRecordType.TEXT_FRAME]: "TEXT_FRAME",
    [AltiumRecordType.JUNCTION]: "JUNCTION",
    [AltiumRecordType.IMAGE]: "IMAGE",
    [AltiumRecordType.SHEET]: "SHEET",
    [AltiumRecordType.SHEET_NAME]: "SHEET_NAME",
    [AltiumRecordType.FILE_NAME]: "FILE_NAME",
    [AltiumRecordType.DESIGNATOR]: "DESIGNATOR",
    [AltiumRecordType.BUS_ENTRY]: "BUS_ENTRY",
    [AltiumRecordType.TEMPLATE]: "TEMPLATE",
    [AltiumRecordType.PARAMETER]: "PARAMETER",
    [AltiumRecordType.PARAMETER_SET]: "PARAMETER_SET",
    [AltiumRecordType.IMPLEMENTATION_LIST]: "IMPLEMENTATION_LIST",
    [AltiumRecordType.IMPLEMENTATION]: "IMPLEMENTATION",
    [AltiumRecordType.MAP_DEFINER_LIST]: "MAP_DEFINER_LIST",
    [AltiumRecordType.MAP_DEFINER]: "MAP_DEFINER",
    [AltiumRecordType.IMPL_PARAMS]: "IMPL_PARAMS",
    [AltiumRecordType.NOTE]: "NOTE",
    [AltiumRecordType.COMPILE_MASK]: "COMPILE_MASK",
    [AltiumRecordType.HARNESS_CONNECTOR]: "HARNESS_CONNECTOR",
    [AltiumRecordType.HARNESS_ENTRY]: "HARNESS_ENTRY",
    [AltiumRecordType.HARNESS_TYPE]: "HARNESS_TYPE",
    [AltiumRecordType.SIGNAL_HARNESS]: "SIGNAL_HARNESS",
    [AltiumRecordType.BLANKET]: "BLANKET",
    [AltiumRecordType.HYPERLINK]: "HYPERLINK",
};
//# sourceMappingURL=recordType.js.map